const Head = () => {
  return (
    <nav
      className="navbar navbar-dark navbar-expand-lg"
      style={{ background: "#203050" }}
    >
      <div className="container">
        <a
          className="navbar-brand"
          href="/"
          style={{
            position: "relative",
            height: "50px",
            bottom: "0px",
            left: "-25px",
            zIndex: 30,
          }}
        >
          <img src="logo.jpg" alt="" />
        </a>
        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
        >
          <h1
            className="position-absolute top-50 start-50 translate-middle"
            style={{
              color: "#ffffffd1",
              fontSize: "1.2rem",
              margin: 0,
              whiteSpace: "nowrap",
            }}
          >
            Checkout de muestras
          </h1>
          <div className="ms-auto">
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/checkout">
                  Salir
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Head;
